function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "rotate(-180 16 16)"
}, React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15,
  fill: "#000",
  fillOpacity: .737,
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeWidth: 2
}), React.createElement("path", {
  fill: "#FFF",
  d: "M13.638 10.038l7.9 4.943a1 1 0 0 1-.013 1.704l-7.9 4.764a1 1 0 0 1-1.517-.857v-9.706a1 1 0 0 1 1.53-.848z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _ref);

export default __webpack_public_path__ + "static/media/arrow-left.338783f5.svg";
export { SvgComponent as ReactComponent };